export default __webpack_public_path__ + "static/media/Imperial Redsteel Slaughter Steed.3727f511.jpg";